import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import isReachable from "../common/isReachable";
import { setOnlineStatus, setVersion, setInvalidVersionCount, setOfflineCount } from "containers/App/_actions";

const useOfflinePoller = () => {
    const dispatch = useDispatch();
    const timerRef = useRef(null);
    const [forceOffline, setForceOffline] = useState(false);

    const online = useSelector((state) => state.app?.online);
    const version = useSelector((state) => state.app?.version);
    const invalidVersionCount = useSelector((state) => state.app?.invalidVersionCount || 0);
    const offlineCount = useSelector((state) => state.app?.offlineCount);

    const toggleOffline = (e) => {
        e.preventDefault();
        const offline = !e.target.checked;
        setForceOffline(offline);
    };

    const checkOffline = () => {
        isReachable()
            .then(([isReachableOnline, serverVersion = ""]) => {
                const isOnline = isReachableOnline && !forceOffline;
                const uiVer = serverVersion.split("+")[0];

                if (uiVer !== version && isOnline) {
                    dispatch(setVersion(uiVer));
                }

                if (process.env.REACT_APP_DISABLE_REFRESH !== "true") {
                    if (uiVer !== process.env.REACT_APP_VERSION.split("+")[0]) {
                        dispatch(setInvalidVersionCount(invalidVersionCount + 1));
                    } else if (invalidVersionCount !== 0) {
                        dispatch(setInvalidVersionCount(0));
                    }
                }

                if (isOnline && !online) {
                    dispatch(setOnlineStatus(true));
                    dispatch(setOfflineCount(0));
                } else if (!isOnline && online) {
                    if (offlineCount < 4) {
                        dispatch(setOfflineCount(offlineCount + 1));
                    } else {
                        dispatch(setOnlineStatus(false));
                    }
                }
            })
            .catch((err) => {
                if (online) {
                    dispatch(setOnlineStatus(false));
                }
            });

        timerRef.current = setTimeout(() => {
            checkOffline();
        }, 10000);
    };

    useEffect(() => {
        timerRef.current = setTimeout(() => {
            checkOffline();
        }, 3000);

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forceOffline, online, version, invalidVersionCount, offlineCount]);

    return { toggleOffline };
};

export default useOfflinePoller;
